import { render, staticRenderFns } from "./VFile.vue?vue&type=template&id=0e559766&scoped=true"
import script from "./VFile.vue?vue&type=script&lang=js"
export * from "./VFile.vue?vue&type=script&lang=js"
import style0 from "./VFile.vue?vue&type=style&index=0&id=0e559766&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e559766",
  null
  
)

export default component.exports